import { HintPosition, type AreaHint, type SimulatorArea } from '@vedalib/editor/lib/elements'

import Padding from 'components/Editor/Toolbar/Padding'
import { FieldRadio, FieldSwitcher, Form, FormField, genDataField } from 'components/formKit'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

import { useSimulatorContext } from '../SimulatorContext'

const genField = genDataField<AreaHint>()

export const ICON_PLACEMENT_OPTIONS = [
  { value: HintPosition.LEFT, label: <Icon name='builderArrowRight' size={KitSize.S} /> },
  { value: HintPosition.BOTTOM, label: <Icon name='builderArrowUp' size={KitSize.S} /> },
  { value: HintPosition.TOP, label: <Icon name='builderArrowDown' size={KitSize.S} /> },
  { value: HintPosition.RIGHT, label: <Icon name='builderArrowLeft' size={KitSize.S} /> },
]

export const position = genField({
  as: FieldRadio,
  name: 'position',
  label: t('input.label.position'),
  layout: 'horizontal',
  props: {
    fluid: false,
    hideRadio: true,
    direction: 'horizontal',
    options: ICON_PLACEMENT_OPTIONS,
  },
})

export const indicator = genField({
  as: FieldSwitcher,
  name: 'indicator',
  label: t('input.label.indicator'),
  layout: 'horizontal',
  info: t('input.tooltip.indicator'),
  defaultValue: true,
  size: KitSize.S,
})

export const onHover = genField({
  as: FieldSwitcher,
  name: 'onHover',
  label: t('input.label.onHover'),
  layout: 'horizontal',
  defaultValue: false,
  size: KitSize.S,
})

export const showCloseButton = genField({
  as: FieldSwitcher,
  name: 'showCloseButton',
  label: t('input.label.showCloseButton'),
  layout: 'horizontal',
  defaultValue: false,
  size: KitSize.S,
})

interface IHintSettingsProps {
  area: SimulatorArea
}

const HintSettings = ({ area }: IHintSettingsProps) => {
  const onChange = useSimulatorContext((c) => c.onChange)
  const value = useSimulatorContext((c) => c.value)
  const onFinish = (values: AreaHint) => {
    onChange?.({
      ...value,
      items: value.items.map((item) => {
        if (!item.areas) {
          return item
        }
        const updatedAreas = item.areas.map((a) => {
          if (a.id === area.id) {
            return { ...a, hint: { ...a.hint, ...values } } as SimulatorArea
          }
          return a
        })
        return { ...item, areas: updatedAreas }
      }),
    })
  }

  return (
    <Form initialValues={area.hint} layout='vertical' name='hintSettings' onChangeValues={onFinish}>
      <Padding bottom gap sides top>
        <FormField config={position} />
        <FormField config={indicator} />
        <FormField config={onHover} />
        <FormField config={showCloseButton} />
      </Padding>
    </Form>
  )
}
export default HintSettings
